import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { en, zhHans } from 'vuetify/lib/locale'
import zhHansLocal from '@/locales/zh-hans.json'
import enLocal from '@/locales/en.json'
Vue.use(VueI18n)

const messages = {
  'zh-hans': { $vuetify: { ...zhHans }, ...zhHansLocal },
  en: { $vuetify: { ...en }, ...enLocal },
}

console.log(zhHans)
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages,
})

export default i18n
